import React, { useState } from 'react';
import classNames from 'classnames';
import { InterviewMarkerList } from '../../../../components/Interview/InterviewMarkerList';
import styles from './styles.module.scss';
import { Card } from 'reactstrap';
import { Interview } from '../../../../entities/Interview';
import { InterviewHighlightsHeader } from '../../../InterviewPage/InterviewHighlightsTab/InterviewHighlightsHeader';
import { HighlightType } from '../../../InterviewPage/Entities/HighlightType';

interface PropTypes {
  interview: Interview;
  playTimestamp: number;
  onTimestampChange: (timestamp: number) => void;
}

export function ScorecardHighlights(props: PropTypes) {
  const [selectedHighlightType, setSelectedHighlightType] = useState(
    'all' as HighlightType,
  );
  return (
    <>
      <InterviewHighlightsHeader
        selectedHighlightType={selectedHighlightType}
        onSelectedHighlightType={setSelectedHighlightType}
      />
      <Card className={classNames('p-3', 'h-100', 'fs-5', styles.container)}>
        <InterviewMarkerList
          selectedHighlightType={selectedHighlightType}
          interview={props.interview}
          playTimestamp={props.playTimestamp}
          menuType={'copy'}
          onSelectTimestamp={props.onTimestampChange}
        />
      </Card>
    </>
  );
}
